(function () {

    'use strict';

    const SELECTED_CATALOG_KEY = "search_procedure_catalog";

    class ProcedureSearchCtrl {
        constructor(catalogService, $mdDialog) {
            this.catalogService = catalogService;
            this.dialog = $mdDialog;

            this.selected = [];
            this.catalogs = [];
            this.selectedCatalog = null;
        }

        static get $inject() {
            return ["catalogService", "$mdDialog"];
        }

        $onInit() {
            this.catalogService.getCatalogs()
                .then(data => {
                    const savedId = parseInt(localStorage.getItem(SELECTED_CATALOG_KEY)) || null;
                    this.catalogs = data;
                    this.selectCatalog(_.find(this.catalogs, ["id", savedId]));
                });
        }

        cancel() {
            this.dialog.cancel();
        }

        selectProcedures() {
            this.dialog.hide(this.selected);
        }

        selectRow(data) {
            this.selected.push(data);
        }

        selectCatalog(catalog = null) {
            this.selectedCatalog = catalog;
            localStorage.setItem(SELECTED_CATALOG_KEY, _.get(this.selectedCatalog, "id", null));

            this.search = this.selectedCatalog ? {
                "_id": {
                    "$in": _.map(this.selectedCatalog.procedures, "id")
                }
            } : {
                is_deleted: {$ne: true}
            };
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        controller: ProcedureSearchCtrl,
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: true,
        template: require("shared/views/procedure-dialog.tpl.html"),
    };

})();